// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__RdajK","content":"styles_content__3BD9u","checkbox":"styles_checkbox__2Fc-9","checkboxLabel":"styles_checkboxLabel__2QF6r"};